import React, { useState, useEffect } from "react";
import { useRecoilValue } from 'recoil';
import { isMobile, isTablet } from "react-device-detect";
import Button from '@material-ui/core/Button';

import * as RemindersApi from '../../../../Common/Apis/RemindersApi';
import { reminderTypeListRefreshState } from '../../store/ReminderTypeStore';
import { useSpinner } from "../../../../../core/contexts/SpinnerContext";
import ReminderTypeListItem from './ListItem';

interface IProps {
  addTab: any;
}

const ReminderTypeList = ({ addTab }: IProps) => {

  const [listData, setListData] = useState();
  const [pageSize, setpageSize] = useState((isMobile && !isTablet) ? 10 : 100);

  const listRefresh = useRecoilValue(reminderTypeListRefreshState);

  const { setSpinner } = useSpinner();

  useEffect(() => {
    getList(1, pageSize);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listRefresh]);


  const pageSizeChanged = (i: number) => {
    setpageSize(i);
    getList(1, i);
  };

  const pageNoChanged = (i: number) => {
    getList(i, pageSize);
  };

  const getList = async (_pageNo: number, _pageSize: number) => {

    setSpinner(true);

    try {

      const resData = await RemindersApi.getReminderTypeList(_pageNo, _pageSize);

      setListData(resData);

      //console.log("resData", resData);

    } catch (err) {
      console.log('err', err);
    }

    setSpinner(false);
  };

  return (
    <>
      <div className="row no-gutters">
        <div className="col-lg-12  mt-3">
          <div className="tab-content" id="myTabContent">
            <div className="card">
              <div className="card-body">
                <div className="row ">
                  <div className="col-lg-2">
                    <div className="form-group">
                      <Button
                        type="submit"
                        //className=" ml-3"
                        style={{ fontWeight: '600' }}
                        variant="contained"
                        color="primary"
                        onClick={() => getList(1, pageSize)}
                      >
                        Refresh
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-12  mt-3">
          <div className="tab-content" id="myTabContent">
            {listData && <ReminderTypeListItem
              items={listData}
              addTab={addTab}
              pageSizeChanged={pageSizeChanged}
              pageNoChanged={pageNoChanged}

            />}

          </div>
        </div>
      </div>
    </>
  );
};

export default ReminderTypeList;